import React, { useEffect, useState } from "react";
import { Avatar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import app from "../../services/base.js";
import "./ChatTitle.scss";
import arrowLeft from "../../assets/arrowLeft.png";
import IconButton from "@material-ui/core/IconButton";

const styles = () => ({
  colorDefault: {
    backgroundColor: "#51A6FF",
    width: "5rem",
    height: "5rem",
  },
  title: {
    marginLeft: 10,
    color: "#303030",
    fontSize: "1.6rem",
  },
  chatTitle: {
    display: "flex",
    alignItems: "center",
    marginTop: "2rem",
    cursor: "pointer",
    marginLeft:20
  },
  fixedMessage: {
    background: "#fff",
    marginTop: "2rem",
    maxHeight: "100%",
    marginRight: 3,
  },
  header: {
    color: "#303030",
    fontSize: "14px",
    marginLeft: 14,
  },
  legend: {
    color: "#404040",
    fontSize: "1.3rem",
    fontWeight: 400,
  },
  divMessage: {
    padding: 12,
    cursor: "pointer",
  },
  labelMessage: {
    color: "#404040",
    border: "1px #fff solid",
    backgroundColor: "#F4F4F4",
    padding: 11,
    fontSize: 14,
    borderLeftColor: "#071FC1",
    borderLeftWidth: 6,
    borderEndStartRadius: 6,
    borderStartStartRadius: 6,
  },
});
const ChatTitle = ({
  selectedConversation,
  classes, 
  setOpenbio,
  showBio, 
}) => {
  const userId = app.auth().currentUser.uid;
  const [targetConversation, setTargetConversation] = useState({});

  let chatTitleContents = null;
  useEffect(() => {
    if (selectedConversation) {
      if (selectedConversation.chatType !== "GroupChat") {
        let targetUser =
          selectedConversation.sender === userId
            ? selectedConversation.receiverUser
            : selectedConversation.senderUser;
        targetUser.id =
          selectedConversation.sender === userId
            ? selectedConversation.receiver
            : selectedConversation.sender;
        targetUser.project =
          selectedConversation.sender === userId
            ? selectedConversation.receiverProject
            : selectedConversation.senderProject;
        setTargetConversation({
          title: `${targetUser.firstName} ${targetUser.lastName}`,
          photoURL: targetUser.photoURL,
          id: targetUser.id,
        });
      } else {
        setTargetConversation(selectedConversation.groupInfo);
      }
    }
  }, [selectedConversation, userId]);

  if (selectedConversation && !showBio) {
    chatTitleContents = (
      <>
        <div id="chat-title">
          <div>
            <div className={classes.chatTitle} onClick={() => setOpenbio(true)}>
              <Avatar
                aria-label="Recipe"
                alt={targetConversation.title}
                src={targetConversation.photoURL}
                className={classes.colorDefault}
              />
              <span className={classes.title}>
                {targetConversation.title || ""}
              </span>
            </div>
          </div>
        </div>
      </>
    );
  } else if (showBio) {
    chatTitleContents = (
      <>
        <div>
          <div>
            <div className={classes.chatTitle}>
              <div className="return-button" onClick={() => setOpenbio(false)}>
                <IconButton color="primary">
                  <img src={arrowLeft} height={20} width={20} alt="Voltar" />
                </IconButton>
              </div>
              <span className={classes.title}>
                {selectedConversation
                  ? `Mais informações de ${targetConversation.title}`
                  : "Informações do grupo"}
              </span>
            </div>
          </div>
        </div>
      </>
    );
  }

  return <>{chatTitleContents}</>;
};

export default withStyles(styles)(ChatTitle);
